import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete-icon",
  "use": "delete-icon-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" id=\"delete-icon\">\n    <path d=\"M6 10H22L20.5801 24.199C20.4779 25.2214 19.6175 26 18.59 26H9.40998C8.38247 26 7.52214 25.2214 7.4199 24.199L6 10Z\" fill=\"currentColor\" />\n    <path d=\"M5 6.75V7C5 7.55228 5.44772 8 6 8H22C22.5523 8 23 7.55228 23 7V6.75C23 6.19772 22.5523 5.75 22 5.75H16.4545L15.6364 5H12.3636L11.5455 5.75H6C5.44772 5.75 5 6.19772 5 6.75Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol